import { DateUTC } from './DateUTC';
import { DateLocalTime } from './DateLocalTime';
import { Link, useNavigate } from 'react-router-dom';
import StoresHeader from '../../assets/StoresHeader';
import { useState, useEffect } from 'react';
import SignOut from '../../assets/SignOut';
import { setNewTimezonePreference } from '../../lib/admin';
import Globe from '../../assets/Globe';
import { useAuth } from '../../utils/authorization';
import { useHasAllStoresAccess, useHasScope } from '../../utils/Permission';

export function Header() {
    const navigate = useNavigate();
    const { user, logout, refresh } = useAuth();
    const isLoggedIn = !!user;
    const isScopeAdmin = useHasScope('admin:users:manage');
    const canViewLogs = useHasScope('logs:view');
    const hasAllStoresAccess = useHasAllStoresAccess();
    const canViewGlobalLogs = canViewLogs && hasAllStoresAccess;

    const [useUTC, setUseUTC] = useState<boolean>(user?.localTimezone ? true : false);

    useEffect(() => {
    }, [user]);

    const handleToggle = async () => {
        const newPreference = !useUTC;
        setUseUTC(newPreference);

        try {
            await setNewTimezonePreference(newPreference);
        } catch (e) {
            setUseUTC(useUTC);
            console.error('Failed to update timezone preference', e);
        }
    };

    const handleLogout = async () => {
        try {
            await logout();
        } finally {
            navigate('/login', { replace: true });
        }
    };

    const navigateToAdmin: () => void = () => {
        navigate(`/admin/users`, { replace: true });
    }

    const navigateToActivity: () => void = () => {
        navigate(`/admin/activity`, { replace: true });
    }

    return (
        <header className="admin-portal-header">
            <div className="header-content">
                <Link className="admin-portal-header-a" to="/stores">
                    <StoresHeader />
                </Link>
            </div>

            <div className="header-date-container">
                {isLoggedIn && (
                    <label>
                        Timezone
                        <input
                            type="checkbox"
                            checked={useUTC}
                            onChange={handleToggle}
                        />
                        UTC
                    </label>
                )}

                {!isLoggedIn ? <DateUTC /> : useUTC ? <DateUTC /> : <DateLocalTime />}
                {
                    ((isScopeAdmin || canViewGlobalLogs) && isLoggedIn) && (
                        <div className="management-container admin">
                            {canViewGlobalLogs && (
                                <button onClick={navigateToActivity} className="admin-icon-btn" aria-label="Global activity" title="Global activity">
                                    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                                        <path fill="currentColor" d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18Zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12Z" />
                                    </svg>
                                </button>
                            )}
                            {isScopeAdmin && (
                                <button onClick={navigateToAdmin} className="admin-icon-btn" aria-label="User management" title="User management">
                                    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                                        <path fill="currentColor" d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3Zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13Zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5Z" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    )
                }

            </div>

            {isLoggedIn && (
                <div className="management-div">
                    <button className="btn-logout" onClick={handleLogout}>
                        <SignOut />
                    </button>
                </div>
            )}
        </header>
    );
}
